import React    from "react";
import template from "./Experiences.jsx";

class Experiences extends React.Component {
  render() {
    return template.call(this);
  }
}

export default Experiences;
